export default __webpack_public_path__ + "static/react-d8a2970115a0276048ff5b96e1e1249d.png";